module.exports = __webpack_public_path__ + "img/699pic_04cl5c_xy2.92faf838.jpg";